import type { SoundEvent, SoundConfig } from './SoundContext';

// Bundled default sounds. Vite emits these as assets and rewrites the imports
// to the published URLs, so consumers get working sound with zero config.
//
// These are real audio clips. Six files cover all events — several events
// share one file (see assets/README.md for the full mapping). Replace a file
// in place to restyle, or override any event via the `sounds` prop on
// <ExerciseRenderer>.
import dragStart from './assets/drag-start.wav';
import dragDrop from './assets/drag-drop.wav';
import buttonClick from './assets/button-click.wav';
import inputSelect from './assets/select-input.wav';
import answerCorrect from './assets/answer-correct.wav';
import answerWrong from './assets/answer-wrong.wav';

export const DEFAULT_SOUNDS: Record<SoundEvent, string> = {
  'drag-start': dragStart,
  'drag-drop': dragDrop,
  'drag-cancel': dragDrop,
  'radio-select': buttonClick,
  'pair-select': buttonClick,
  'pair-link': buttonClick,
  'pair-unlink': buttonClick,
  'keypad-press': buttonClick,
  'matcher-select': buttonClick,
  'fraction-shade': buttonClick,
  'clock-hour-tick': buttonClick,
  'clock-minute-tick': buttonClick,
  'counter-step': buttonClick,
  'cursor-step': buttonClick,
  'cursor-release': dragDrop,
  'input-select': inputSelect,
  'answer-correct': answerCorrect,
  'answer-wrong': answerWrong,
};

/** Merge consumer overrides over the bundled defaults. */
export function resolveSounds(overrides?: SoundConfig): SoundConfig {
  return overrides ? { ...DEFAULT_SOUNDS, ...overrides } : DEFAULT_SOUNDS;
}
